import { h, Component } from 'preact'
import { NavDrawer } from 'react-toolbox/lib/layout'
import Navigation from 'react-toolbox/lib/navigation'
import { List, ListItem } from 'react-toolbox/lib/list'
import FontIcon from 'react-toolbox/lib/font_icon'
import Brand from './../brand/Brand'
import style from './style'

export default class DrawerPage extends Component {
  render({ active, pinned, onOverlayClick }) {
    return (
      <NavDrawer
        class={style.nav}
        active={active}
        permanentAt="lg"
        onOverlayClick={onOverlayClick}>
        <section class={style.header}>
          <Brand />
        </section>
        <Navigation type="vertical">
          <List selectable ripple>
            <ListItem
              class={style.link}
              to="/"
              title="Home"
              caption="Home"
              leftIcon="home"
              onClick={onOverlayClick}
            />
            <ListItem
              class={style.link}
              to="/cigar"
              title="Compound Annual Growth Rate"
              caption="CIGAR"
              //leftIcon="assessment"
              leftIcon="timeline"
              onClick={onOverlayClick}
            />
            <ListItem
              class={style.link}
              to="/accounts"
              title="Accounts"
              caption="Accounts"
              leftIcon="account_balance"
              onClick={onOverlayClick}
            />
          </List>
        </Navigation>
      </NavDrawer>
    )
  }
}



// WEBPACK FOOTER //
// ./components/navDrawer/NavDrawer.js